module.exports = __webpack_public_path__ + "img/404_image.1fe63773.svg";